import React from 'react';
import proptypes from 'prop-types';
import { Popover } from '@one-thd/sui-atomic-components';

const {
  bool, string, shape, func, node
} = proptypes;

export const Tooltip = ({
  open,
  anchorEl,
  onClose,
  placement,
  children
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      placement={placement}
      disableEnforceFocus
      disableRestoreFocus
      onMouseEnter={(event) => {
        event.stopPropagation();
      }}
      onMouseLeave={(event) => {
        onClose(event);
      }}
    >
      <div data-super-sku-popover>
        {children}
      </div>
    </Popover>
  );
};

Tooltip.propTypes = {
  open: bool.isRequired,
  anchorEl: shape({}),
  onClose: func.isRequired,
  placement: string,
  children: node
};

Tooltip.defaultProps = {
  anchorEl: null,
  placement: 'top',
  children: null
};